module.exports = __webpack_public_path__ + "img/sheffield-united.e51cd07f.png";